// src/features/auth/Routes.jsx
import React from 'react';
import { Route } from 'react-router-dom';
import LoginPage from './pages/LoginPage/LoginPage';
import ChangeUserPage from './pages/ChangeUserPage/ChangeUserPage';
import UnauthorizedPage from './pages/UnauthorizedPage';
import PrivacyPolicyPage from './pages/PrivacyPage';

export const AuthRoutes = () => (
  <>
    <Route path="/login" element={<LoginPage />} />
    <Route path="/auth/change-user" element={<ChangeUserPage />} />
    <Route path="/unauthorized" element={<UnauthorizedPage />} />
    <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
  </>
);